<form>
  <payee-chip-dropdown
    [displayWith]="displayWith"
    [placeholder]="'CASES_TABLE.FILTERS.DEBTOR_NAME.LABEL' | translate"
    [selected]="selected"
    [(dropdownOpen)]="dropdownOpen"
    (removed)="clearFilter()"
  >
    <payee-form-field>
      <input
        payee-input
        [formControl]="debtorNameControl"
        [placeholder]="'CASES_TABLE.FILTERS.DEBTOR_NAME.PLACEHOLDER' | translate"
        [matAutocomplete]="auto"
        (input)="onDebtorSearchInput($event)"
        (paste)="onPaste($event)"
      />
      @if (debtorNameControl.invalid && debtorNameControl.dirty) {
        <span payee-error>
          {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
        </span>
      }
      @if (loading()) {
        <span payee-suffix>
          <mat-progress-spinner
            mode="indeterminate"
            diameter="24"
          ></mat-progress-spinner>
        </span>
      }
      <mat-autocomplete
        #auto="matAutocomplete"
        [requireSelection]="false"
      >
        @for (option of debtorOptions; track option.name) {
          <mat-option [value]="option.name">
            {{ option.name }}
          </mat-option>
        }
      </mat-autocomplete>
    </payee-form-field>
    <button
      payee-button
      class="top-margin-10"
      color="primary"
      (click)="applyFilter()"
    >
      {{ "CASES_TABLE.FILTERS.APPLY" | translate }}
    </button>
  </payee-chip-dropdown>
</form>
